import { QuestionCircleOutlined, SyncOutlined } from '@ant-design/icons';
import { t, Trans } from '@lingui/macro';
import { Tag } from 'antd';
import BukkuTooltip from 'bukku/components/Tooltip';
import dayjs from 'dayjs';
import React from 'react';
import { BankFeedConnectionStatus } from '../../../../BankFeedConnect/enums/BankFeedConnectionStatus';
import BankAccountTag from '../../../../BankFeedConnect/components/BankAccountTag';

export default function AccountConnectStatusTag({connectStatus, connectedTo, lastSyncUntil = null, bank}) {
    const lastSyncUntilString = lastSyncUntil ? dayjs(lastSyncUntil).format('DD/MM/YYYY') : null;

    if (connectStatus) {
        switch (connectStatus) {
            case BankFeedConnectionStatus.CONNECTED:
                if (lastSyncUntil) {
                    return (
                        <BukkuTooltip title={
                            <div>
                                <TooltipConnectedTo bank={bank} connectedTo={connectedTo} />
                                <br />
                                <Trans>
                                    {`Last synced until: ${lastSyncUntilString}`}
                                </Trans>
                            </div>
                        }
                        >
                            <Tag color="green" style={{marginRight: 0}}>
                                <Trans>Connected</Trans>
                                &nbsp;
                                <SyncOutlined />
                            </Tag>
                        </BukkuTooltip>
                    );
                }
                return (
                    <BukkuTooltip title={<TooltipConnectedTo bank={bank} connectedTo={connectedTo} />}>
                        <Tag color="green" style={{marginRight: 0}}>
                            <Trans>Connected</Trans>
                        </Tag>
                    </BukkuTooltip>
                );
            case BankFeedConnectionStatus.NOT_CONNECTED:
                return <Tag style={{marginRight: 0}}><Trans>Not Connected</Trans></Tag>;
            case BankFeedConnectionStatus.PENDING:
            default:
                return (
                    <Tag color="orange" style={{marginRight: 0}}>
                        <Trans>Pending</Trans>
                            &nbsp;
                        <BukkuTooltip title={t`Pending checker's approval in Maybank.`}>
                            <QuestionCircleOutlined />
                        </BukkuTooltip>
                    </Tag>
                );
        }
    }
    return null;
}

function TooltipConnectedTo({bank, connectedTo}) {
    return (
        <>
            Connected to:&nbsp;
            <BankAccountTag
                bankCode={bank}
                accountNumber={connectedTo}
            />
        </>
    );
}
